"use strict";

var _slicedToArray = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgeGate = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _bodyScrollLock = require("body-scroll-lock");

var _all = require("gsap/all");

var _styles = require("./styles");

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AgeGate = function AgeGate(_ref) {
  var logo = _ref.logo,
      title = _ref.title,
      yesMessage = _ref.yesMessage,
      noMessage = _ref.noMessage,
      colorMode = _ref.colorMode;
  var tlRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);
  var titleRef = (0, _react.useRef)(null);

  var _ref2 = (0, _react.useState)(null),
      _ref3 = _slicedToArray(_ref2, 2),
      rootRef = _ref3[0],
      setRootRef = _ref3[1];

  (0, _react.useEffect)(function () {
    console.log('hello!');
    setRootRef(document.getElementById('gatsby-focus-wrapper') || document.getElementById('root'));

    if (rootRef) {
      buildTimeline();
      (0, _bodyScrollLock.disableBodyScroll)(rootRef);
    }
  }, [rootRef]);
  (0, _react.useEffect)(function () {
    return function () {
      if (tlRef.current) {
        tlRef.current.kill();
      }

      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    };
  }, []);

  var buildTimeline = function buildTimeline() {
    tlRef.current = _all.gsap.timeline().to(rootRef, {
      duration: 1,
      filter: 'blur(5px) brightness(5.5)',
      opacity: 0.8
    }).from(containerRef.current, {
      opacity: 0,
      duration: 1
    }, '<');
  };

  function closeAgeGate() {
    tlRef.current = _all.gsap.timeline().to(rootRef, {
      duration: 0.6,
      filter: 'blur(0px) brightness(1)',
      opacity: 1
    }).to(containerRef.current, {
      opacity: 0,
      display: 'none',
      duration: 0.6
    }, '<').to(rootRef, {
      filter: '',
      duration: 0.01
    });
    (0, _bodyScrollLock.enableBodyScroll)(rootRef);
  }

  function redirectToHomepage(event) {
    window.location.href = 'https://www.highsnobiety.com';
  }

  var fluid = (logo === null || logo === void 0 ? void 0 : logo.fluid) || (logo === null || logo === void 0 ? void 0 : logo.responsiveImage) || logo;
  return _reactDom.default.createPortal(_react.default.createElement(_styles.Container, {
    ref: containerRef
  }, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Content, null, fluid && _react.default.createElement(_styles.Image, {
    srcSet: fluid.srcSet,
    src: fluid.src
  }), _react.default.createElement(_styles.Title, {
    ref: titleRef,
    colorMode: colorMode
  }, title), _react.default.createElement(_styles.ButtonsContainer, {
    colorMode: colorMode
  }, _react.default.createElement(_styles.Button, {
    onClick: closeAgeGate
  }, yesMessage), _react.default.createElement(_styles.Button, {
    onClick: redirectToHomepage
  }, noMessage)))), document.body);
};

exports.AgeGate = AgeGate;